import React, {useEffect} from "react";
import {connect} from "react-redux";
import {setUpdateButtonActiveStepToFalse,
        setUpdateButtonActiveStepToTrue
       } from '../../../../store/actions/main';
import {updateStepsGelaender,
        updateWrapperIndexGelaender,
        updateBefestigungsartGelaender
        } from '../../../../store/actions/gelaender';
import {pfosten_befestigungsart} from '../../../../../assets/images/data';
import scrollToElement from '../../../../module/scrollToElement';


const Step_6 = (props) => {

   useEffect(() => {
      updateItems();
   })

   const updateItems = () => {
        const {befestigungsart} = props.data[props.modell_type];
        let befestigungs_wrapper = document.querySelectorAll('.befestigungsWrapperItems img');
        let befestigungs_index = props.data[props.modell_type].wrapper[0].wrapper6;

        //scroll to Next Button Container
        if (befestigungsart) scrollToElement();

        //remove check from box
        for (let i = 0; i < befestigungs_wrapper.length; i++) {
            befestigungs_wrapper[i].classList.remove('check');
        }
        //add check to box
        if(befestigungsart && befestigungs_wrapper[befestigungs_index]) {
            befestigungs_wrapper[befestigungs_index].classList.add('check');
        }

        //update steps
        if (props.modell_type === 0||props.modell_type === 2) props.updateSteps(6);
        if (props.modell_type === 3) props.updateSteps(4);
        else {props.updateSteps(5);}

        if(befestigungsart || props.data[props.modell_type].allVisitedSteps) {
            //update steps
            if (props.modell_type === 0||props.modell_type === 2) props.updateSteps(7);
            if (props.modell_type === 1 || props.modell_type === 2) props.updateSteps(6);
            if (props.modell_type === 3) props.updateSteps(5);
            props.setUpdateButtonActiveStepToFalse();
        } else {
            props.setUpdateButtonActiveStepToTrue()
        }

   }

   const updateBefestigungsart = ev => {
        let handrail_endkappe = ev.currentTarget.getAttribute('titel');
        let wrapperObject = {
            ident: 6,
            index: ev.currentTarget.getAttribute('index')
         }

        props.updateBefestigungsart(handrail_endkappe);
        props.updateWrapperIndex(wrapperObject);
        updateItems();
   }


    return (
        <div className="step_wrapper">
              <div className="step_icon_wrapper befestigungs_wrapper">
                <h2 className='step_header handlauf'>Welche Befestigungsart?</h2>
                <div className="inner-befestigungs-wrapper">
                    {pfosten_befestigungsart.map((elem, index) => (
                        props.modell_type === 3 && elem.titel === "Befestigung von Unten"?''
                        :
                        <div className="befestigungsWrapperItems" onClick={updateBefestigungsart} key={index} index={index} titel={elem.titel}>
                            <img className="befestigung" src={elem.imgsrc} alt={elem.titel}/>
                            <p>{elem.titel}</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = state => {
    return {
        modell_type: state.gelaenderReducer.modell_type,
        data: state.gelaenderReducer.data
    }
}

const mapDispatchToProps = dispatch =>  {
   return {
      setUpdateButtonActiveStepToFalse: () => dispatch(setUpdateButtonActiveStepToFalse()),
      setUpdateButtonActiveStepToTrue: () => dispatch(setUpdateButtonActiveStepToTrue()),
      updateSteps: ev => dispatch(updateStepsGelaender(ev)),
      updateWrapperIndex: ev => dispatch(updateWrapperIndexGelaender(ev)),
      updateBefestigungsart: ev => dispatch(updateBefestigungsartGelaender(ev))

   }
}


export default connect(mapStateToProps, mapDispatchToProps)(Step_6);
